<template>
		 <div class = "part" v-if = "everyPart" >
			<div class="hide-anchor" :id= "'anchor-'+index"></div>
			<div class="part-top" >
					<p class = "part-name">
						<!-- <span class = "part-line">—</span>&nbsp;&nbsp;{{sliderList.title}}&nbsp;&nbsp; <span class = "part-line">—</span> -->
						<span class = "part-line">—</span>&nbsp;&nbsp;{{sliderList.title}}&nbsp;&nbsp; <span class = "part-line">—</span>
					</p>
					<p class = "part-reason">{{sliderList.reason}}</p>
			</div>
			<ul class="item-wrap" >
					<item :item ="item" v-for="(item,index) in everyPart.dataList" :key ="item.id" :index = "index" :partid = "sliderList.id"></item>
			</ul>
			<div class = "part-bottom"  v-if = "islastPage === '0'">
				<div class="show-more" v-on:click ="showMore()">查看更多</div>
				<span class = "show-more-triangle"></span>
			</div>
	</div>
	<div v-else-if = "!everyPart">
		<img src = "//img.58cdn.com.cn/job/img/maggregation_default_bg.png" class = "part_default_img"/>
	</div>
</template>
<script>
import data from '../../api/index.js';

import {mapState} from 'vuex';
import item from './item';
export default {
	components: {
		item
	},
	computed: {
		...mapState([
			'mcity',
			'source',
			'dispcateid',
			'userid',
			'isShowAllPart',
			'currentPart'
		])
	},
	data() {
		return {
			minHeight: 150, //滑动时下一个模块显示出来的最小高度，当大于这个高度时切换currentpPart
			showPopIndex: 2, //滑动到模块3的时候判断是否显示气泡，index是从0基计数的，所以值为2
			everyPart: null, //每一个木块的数据
			page: 1, //当前是第几页
			maxpage: 3, //加载更多最多点击两次
			islastPage: 0 //是否有下一页 0有 1没有
		};
	},
	props: [
		'sliderList', //顶部滑动导航栏
		'index',
		'scrollTop',
		'clientHeight'
	],
	methods: {
		/**
		 * [showMore 查看更多]
		 * @AuthorHTL
		 * @DateTime  2017-07-10T16:07:24+0800
		 * @return    {[type]}                 [description]
		 */
		showMore() {
		/**
		 * [getData 获取下一页数据]
		 * @AuthorHTL yuxue02
		 * @DateTime  2017-07-10T16:07:24+0800
		 * @param     {[type]}                 sliderList.id [每个模块对应的id]
		 * @param     {[type]}                 page [页码]
		 * @param     {[type]}                 mcity [cookie中取得city]
		 * @param     {[type]}                 source [url中取得页面来源]
		 * @param     {[type]}                 dispcateid [url中取得dispcateid仅用于透传]
		 * @return    {[type]}                 responseData[description]
		 */
			data.getData(this.sliderList.id, this.page, this.mcity, this.source, this.dispcateid)
				.then((responseData) => {
					if (responseData.state) {
						this.everyPart.dataList = this.everyPart.dataList.concat(responseData.dataList);
						this.$store.commit({
							type: 'CHANGE_CURRENTPART',
							currentPart: this.index});
						this.page += 1;
						this.islastPage = responseData.lastPage;
					}
				}).catch(err => console.log(err));
			window.clickLog && window.clickLog('from=m_aggregation_more' + (this.index + 1));
		},
		/**
		 * [winScroll 判断滚动到哪个部分]
		 * @AuthorHTL
		 * @DateTime  2017-07-10T16:07:51+0800
		 * @return    {[type]}                 [description]
		 */
		winScroll(scrollTop) {
			if (!this.isShowAllPart) {
				let sub = this.clientHeight - (this.$el.offsetTop - scrollTop);
				if (this.minHeight < sub && sub <= (this.$el.offsetHeight + this.minHeight)) {
				// if(this.minHeight<this.clientHeight-(this.$el.offsetTop - scrollTop) && this.clientHeight-(this.$el.offsetTop - scrollTop)<= this.$el.offsetHeight){
					this.$store.commit({
						type: 'CHANGE_CURRENTPART',
						currentPart: this.index
					});
					if (this.index === this.showPopIndex && this.userid) {
						this.$store.dispatch('getApplyNum', this.userid);
					}
				}
			}
		}
	},
	mounted() {
		/**
		 * [getData 获取每个模块数据]
		 * @AuthorHTL yuxue02
		 * @DateTime  2017-07-10T16:07:24+0800
		 * @param     {[type]}                 sliderList.id [每个模块对应的id]
		 * @param     {[type]}                 page [页码]
		 * @param     {[type]}                 mcity [cookie中取得city]
		 * @param     {[type]}                 source [url中取得页面来源]
		 * @param     {[type]}                 dispcateid [url中取得dispcateid仅用于透传]
		 * @return    {[type]}                 responseData[description]
		 */
		data.getData(this.sliderList.id, this.page, this.mcity, this.source, this.dispcateid)
			.then((responseData) => {
				if (responseData.state) {
					this.page += 1;
					this.everyPart = responseData;
					this.islastPage = responseData.lastPage;
				}
			}).catch(err => console.log(err));
	},
	watch: {
		scrollTop: function(val) {
			this.winScroll(val);
		}
	}
};
</script>
<style lang = "scss">
@import  "../../assets/style/public.scss";
.part_default_img{
	width:100%;
}
.part{
	background:#F6F6F6;
	.hide-anchor{
		position:relative;
		top:px2rem(-88px);
	}
	.part-top{
		height:px2rem(162px);
		text-align:center;
		color:#aaa;
		font-size:px2rem(30px);
		background:#F6F6F6;
		.part-name{
			padding-top:px2rem(46px);
			.part-line{
				font-weight: lighter;
				color: #ddd;
			}
		}
		.part-reason{
			font-size:px2rem(24px);
			line-height:px2rem(40px);
		}
	}
	.part-bottom{
		position: relative;
		width: 100%;
		height:px2rem(90px);
		background: $white;
		border-top:1px solid #f3f3f3;
		.show-more{
			line-height: px2rem(90px);
			width:px2rem(118px);
			margin: 0 auto;
			text-align: center;
			padding:0 px2rem(10px);
			font-size:$font-size;
			color:#666;
		}
		.show-more-triangle{
			display: inline-block;
			height: 100%;
			width:px2rem(10px);
			position: absolute;
			top:0;
			left:59%;
			&:after{
			content:'\e900';
			position: absolute;
			font-family: "iconfont" !important;
			font-size: px2rem(20px);
			line-height: px2rem(90px);
			color: #e6e6e6;
			}
		}
	}
}
	
</style>


// WEBPACK FOOTER //
// part.vue?8440e410